<div class="content"
     [ngClass]="{'empty': (data | async)?.reads?.length === 0}">
    <div class="title"
         data-automation-e2e-selector="title">
        MMD Reads
    </div>
    <div class="none"
        *ngIf="(data | async)?.reads?.length === 0">
        No reads available
    </div>
    <div *ngIf="(data | async)?.reads?.length > 0"
         id="itemListWrapperId"
         class="itemListWrapper">
        <ul id="itemListId" 
            class="itemList"
            data-automation-e2e-selector="itemsList">
            <li *ngFor="let item of (data | async)?.reads; let id = index"
                data-automation-e2e-selector="item">
                <span class="item">
                    <span class="years"
                          data-automation-e2e-selector="years">
                        {{item.years}}:&nbsp;
                    </span>
                    <span [ngClass]="{'bump': item.isBump, 'cut': item.isCut}"
                          data-automation-e2e-selector="yearValue">
                        {{item.change}}
                    </span>
                </span>
            </li>
        </ul>
    </div>
    <div class="disclaimer"
         data-automation-e2e-selector="disclaimer">
        Municipal yield curve and Early Read data provided by MMD. Ipreo reserves the right to remove MMD content for non-subscribers. Email <a href="mailto:clientservice@tm3.com">clientservice@tm3.com</a> or call 1-800-367-8251 for full MMD access.
    </div>
</div>